<template>
  <v-btn class="mr-2" dark color="green" @click.prevent="submit">{{
    getSubmitLabel
  }}</v-btn>
</template>

<script>
import entities from "../api/entities";

export default {
  name: "SubmitButton",
  props: [
    "id",
    "type",
    "submitLabel",
    "persistence",
    "mode",
    "scope",
    "popup",
    "continue"
  ],
  methods: {
    async submit() {
      console.log(
        "SubmitButton.submit",
        "id:",
        this.id,
        "persistance:",
        this.persistence,
        "mode:",
        this.mode
      );
      this.$store.state.dialog.result = null;
      // TODO: refactoring
      // Сообщения об ошибках проверки данных должны выводиться тут, а общие,
      // такие как ошибки аутентификации - в axios.interceptors

      if (this.persistence == "dependent") {
        if (this.mode == "edit") {
          // редактирование записей
          this.$root.$emit(
            "change_list_item",
            this.type,
            this.$parent.entity,
            this.$parent._entity,
            this.$parent
          );
        } else {
          // получить родительское поле и добавить в его записи новую
          this.$root.$emit(
            "add_to_list",
            this.type,
            this.$parent.entity,
            this.$parent
          );
        }
      } else {
        let result = false;
        if (this.id) {
          result = await entities.update(
            this.token,
            this.type,
            this.id,
            this.$parent.entity
          );
          if (result.success)
            this.$root.$emit("notify", "Запись изменена", "green");
        } else {
          result = await entities.create(
            this.token,
            this.type,
            this.$parent.entity,
            this.scope
          );
          if (result.success)
            this.$root.$emit("notify", "Запись создана", "green");
        }
        if (!this.popup && result && result.success && !this.continue)
          this.$router.push({
            name: "entities_list",
            params: { type: this.type, scope: this.scope }
          });

        if (result && result.success) this.$parent.$emit("close");
        if (result && !result.success && result.error === "DATA_ERROR") {
          this.$parent.errors = result.message;
          this.$root.$emit("notify", result.message, "red");
        }
      }
    }
  },
  computed: {
    getSubmitLabel() {
      if (this.submitLabel) {
        return this.submitLabel;
      }

      if (this.persistence == "dependent") {
        return "Принять";
      } else {
        if (!this.continue) {
          return this.id ? "Сохранить" : "Создать";
        } else {
          return "Сохранить и продолжить";
        }
      }
    }
  }
};
</script>

<style scoped></style>
